import { render, staticRenderFns } from "./DashboardFranchiseeFavorite.vue?vue&type=template&id=3005da74&scoped=true&"
import script from "./DashboardFranchiseeFavorite.vue?vue&type=script&lang=js&"
export * from "./DashboardFranchiseeFavorite.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFranchiseeFavorite.vue?vue&type=style&index=0&id=3005da74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3005da74",
  null
  
)

export default component.exports